import {useInfiniteQuery, useMutation, useQuery} from "@tanstack/react-query";
import {
    getAwardDetail,
    getAwards,
    getAwardsGamification, getAwardsRace, getRaceAwards,
    getTakeAward,
    getTopList,
    postTakeAward
} from "../../../data/api/award";
import {getGamificationGuide} from "../../../data/api/setting";

export const useGetAwards = () => {
    return useQuery({
        queryKey: ['home', 'awards'],
        queryFn: () => getAwards(),
    })
}

export const useGetAwardsGamification = (args, config) => {
    return useQuery({
        queryKey: ['awards','gamification', args],
        queryFn: () => getAwardsGamification(args),
        ...config,
    })
}

export const useTakeAward = () => {
    return useMutation({
        mutationFn : (args) =>
            postTakeAward(args)
    })
}
export const useGetTakeAwards = (args, config) => {
    return useInfiniteQuery({
        queryKey: ['awards','take', 'my_award', args],
        queryFn: ({pageParam = 1}) => getTakeAward({...args, page: pageParam}),
        ...config,
        getNextPageParam: lastPage =>
            lastPage.meta.currentPage < lastPage.meta.lastPage ? lastPage.meta.currentPage + 1 : undefined,
    })
}
export const useGetAwardsRace = (args, config) => {
    return useInfiniteQuery({
        queryKey: ['awards','race', args],
        queryFn: ({pageParam = 1}) => getAwardsRace({...args, page: pageParam}),
        ...config,
        getNextPageParam: lastPage =>
            lastPage.meta.currentPage < lastPage.meta.lastPage ? lastPage.meta.currentPage + 1 : undefined,
    })
}
export const useGetGamificationGuide = () => {
    return useQuery({
        queryKey: ['guide', 'gamification'],
        queryFn: () => getGamificationGuide()
    })
}
export const useGetAwardDetail = (id) => {
    return useQuery({
        queryKey: ['home', 'award', id],
        queryFn: () => getAwardDetail(id),
    })
}

export const useGetTopList = () => {
    return useQuery({
        queryKey: ['topList'],
        queryFn: () => getTopList()
    })
}